<template>
    <div class="buy_alert">
        <div class="t1">
            <div class="con1">
                <img src="~@/../static/image/icon8.png" alt="">
                <div class="y1">
                    <span class="u1">选择基础信息</span><br>
                    <span class="u2">创建基础信息</span>
                </div>
            </div>
            <div class="con1">
                <img src="~@/../static/image/icon8.png" alt="">
                <div class="y1">
                    <span class="u1">确认信息内容</span><br>
                    <span class="u2">请确认详细的信息内容</span>
                </div>
            </div>
            <div class="con1">
                <img src="~@/../static/image/icon8.png" alt="">
                <div class="y1">
                    <span class="u1">完成支付</span><br>
                    <span class="u2">支付成功</span>
                </div>
            </div>
        </div>

        <div class="t2">
            <img src="" alt="">
            <span class="tit">预订成功！感谢您的预订</span>
            <span class="odd">您的订单号：12345678</span>
            <span class="odd">您已完成付款，请等待出票</span>
        </div>

        <div class="t3">
            <div class="tit2">
                <span>预定成功说明</span>
            </div>
            <div class="con">
                <span class="tt1">出票完成后您将收到邮件通知，查询出票情况请前往</span>
                <span class="tt2">订单中心</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"buy_alert",
}
</script>

<style scoped>
.buy_alert {
    width: 1100px;
    height: 601px;
    background: rgb(255, 255, 255);
    border-radius: 10px;
    margin: 0 auto;
    margin-top:5%;
    display: flex;
    flex-direction: column;
}
.buy_alert .t1 {
    display: flex;
    margin-left: 11%;
    margin-top: 5%;
}
.buy_alert .t1 .con1{
    margin: 0 auto;
    flex: 0 0 35%;
    display: flex;
}
.buy_alert .t1 .con1 img{
    width: 27.09px;
    height: 28px;
    margin-right: 2%;
}
.buy_alert .t1 .con1 .u1{
    color: rgb(78, 89, 105);
    font-family: Noto Sans SC;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0%;
    text-align: left;
}
.buy_alert .t1 .con1 .u2{
    color: rgb(134, 144, 156);
    font-family: Noto Sans SC;
    font-size: 12px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0%;
    text-align: left;
}
.buy_alert .t2 {
    margin: 0 auto;
    margin-top: 15%;
    display: flex;
    flex-direction: column;
}
.buy_alert .t2 .img{
    width: 45px;
    height: 45px;
}
.buy_alert .t2 .tit{
    color: rgb(0, 0, 0);
    font-family: Noto Sans SC;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0%;
    text-align: center;

}
.buy_alert .t2 .odd{
    color: rgb(78, 89, 105);
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0%;
    text-align: center;

}
.buy_alert .t3 {
    margin: 0 auto;
    margin-top: 5%;
    width: 45vw;
    height: 13vh;
    background: rgb(247, 248, 250);
}
.buy_alert .t3 .tit2{
    margin-left: 2%;
    margin-top: 2%;
}
.buy_alert .t3 .tit2 span{
    color: rgb(29, 33, 41);
    font-family: Noto Sans SC;
    font-size: 16px;
    font-weight:600;
    line-height: 24px;
    letter-spacing: 0%;
    text-align: left;
}
.buy_alert .t3 .con{
    margin-left: 2%;
    margin-top: 1%;
    display: flex;
}
.buy_alert .t3 .con .tt1{
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0%;
    text-align: left;

}
.buy_alert .t3 .con .tt2{
    font-family: Noto Sans SC;
    color: blue;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0%;
    text-align: left;

}

</style>


// WEBPACK FOOTER //
// src/pages/index/buy_alert.vue